/**
 * Generate the next sequential invoice number for the firm.
 *
 * Format: INV-YYYYMMDD-NNN
 *   YYYYMMDD  — today's date (no dashes)
 *   NNN       — firm-wide sequential counter, padded to 3 digits (grows beyond 999 if needed)
 *
 * @param {Array} allInvoices  Full list of firm invoices already in memory (or [])
 * @returns {string}  e.g. "INV-20260507-001"
 */
export function nextInvoiceNumber(allInvoices = []) {
  const now = new Date();
  const stamp =
    `${now.getFullYear()}` +
    `${String(now.getMonth() + 1).padStart(2, '0')}` +
    `${String(now.getDate()).padStart(2, '0')}`;

  const max = allInvoices.reduce((best, inv) => {
    const m = (inv.invoice_number || '').match(/(\d+)$/);
    const n = m ? parseInt(m[1], 10) : 0;
    return n > best ? n : best;
  }, 0);

  const seq = String(max + 1).padStart(3, '0');
  return `INV-${stamp}-${seq}`;
}
